import { Util } from '@grandvisionhq/forms'

export const isValidStreetName = (val: string) => Boolean(/\w.*\d/.exec(val))

export const isPostalCode =
  (country: string) =>
  (value: string): boolean =>
    Util.validations.isValidPostalCodeForCountry(country, value)
